import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container" style={{
      maxWidth: '800px',
      margin: '40px auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '24px', marginBottom: '20px', color: '#333' }}>
        Privacy Policy for ABSA Sports Academy WhatsApp Booking Service
      </h1>
      
      <h2 style={{ fontSize: '18px', marginTop: '25px', marginBottom: '10px', color: '#555' }}>
        Data Collection
      </h2>
      <p style={{ marginBottom: '15px', color: '#666' }}>
        We collect phone numbers and booking information to provide court booking services. 
        This information is used solely for the purpose of managing your bookings and communicating 
        with you regarding your reservations.
      </p>
      
      <h2 style={{ fontSize: '18px', marginTop: '25px', marginBottom: '10px', color: '#555' }}>
        Payment Processing
      </h2>
      <p style={{ marginBottom: '15px', color: '#666' }}>
        Payment processing is handled by PayU. Your payment information is processed securely 
        through their platform and we do not store your payment details on our servers.
      </p>
      
      <h2 style={{ fontSize: '18px', marginTop: '25px', marginBottom: '10px', color: '#555' }}>
        Data Sharing
      </h2>
      <p style={{ marginBottom: '15px', color: '#666' }}>
        We do not share your data with third parties except for payment processing. Your personal 
        information is kept confidential and used only for providing our booking services.
      </p>
      
      <h2 style={{ fontSize: '18px', marginTop: '25px', marginBottom: '10px', color: '#555' }}>
        Data Storage and Retention
      </h2>
      <p style={{ marginBottom: '15px', color: '#666' }}>
        Your data is stored securely using industry-standard security measures. You may request 
        deletion of your data at any time, and we will process such requests promptly.
      </p>
      
      <h2 style={{ fontSize: '18px', marginTop: '25px', marginBottom: '10px', color: '#555' }}>
        Contact Us
      </h2>
      <p style={{ marginBottom: '15px', color: '#666' }}>
        If you have any questions about our privacy policy or how we handle your data, please 
        contact us through our official channels.
      </p>
    </div>
  );
};

export default PrivacyPolicy;